import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://www.tumundoequilibrado.com/cart/51454727455015:1';
export function CTAButton({
  children,
  onClick,
  className = ''
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.location.href = CHECKOUT_URL;
    }
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`bg-gradient-primary text-white font-body font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all text-lg sm:text-xl w-full sm:w-auto ${className}`} data-id="element-31">
      {children}
    </motion.button>;
}